
import { Component, ContentChildren, ElementRef, HostListener, Input, QueryList, ViewChild } from '@angular/core';

@Component({
    selector: 'logo-slider',
    standalone: true,
    imports: [],
    templateUrl: './logo-slider.component.html',
    styleUrl: './logo-slider.component.scss'
})
export class LogoSliderComponent {
    @Input() logos: string[] = [];
    @ViewChild('sliderContainer', { static: false }) container!: ElementRef;
    @ViewChild('sliderWrapper') sliderWrapper!: ElementRef<HTMLDivElement>;

    currentIndex = 0;
    visibleCount = 5; // logos shown at once

    ngAfterViewInit() {
        this.updateSlide();
        this.startAutoPlay();
        window.dispatchEvent(new Event('resize')); // Trigger a resize event so the sidebar can update
    }

     /** When the window is resized, we handle the changes in the sidebar */
     @HostListener('window:resize', ['$event'])
     onResize(event: any) {
        if (this.sliderWrapper)
        {
            const width = this.sliderWrapper.nativeElement.offsetWidth;
            this.visibleCount = 5;

            if (width < 800)
                this.visibleCount = 4;
            if (width < 600)
                this.visibleCount = 3;
            if (width < 480)
                this.visibleCount = 1;
          }
     }

    next() {
        if (this.currentIndex < this.logos.length - this.visibleCount)
            this.currentIndex++;
        else
            this.currentIndex = 0;

        this.updateSlide();
    }

    prev() {
        if (this.currentIndex > 0)
            this.currentIndex--;
        else
            this.currentIndex = this.logos.length - 1;

        this.updateSlide();
    }

    updateSlide() {
        const offset = this.currentIndex * (100 / this.visibleCount);
        this.container.nativeElement.style.transform = `translateX(-${offset}%)`;
    }

    startAutoPlay() {
        setInterval(() => {
            this.next();
        }, 3000);
    }
}
